import { apiGet } from '../../api'

export const get_program_information = program_id => {
  return apiGet({
    endpoint: `programs/get_program_information?id=${program_id}`
  })
}
